export const AppNotificationNamespace = 'AppNotification';
export default {
  [AppNotificationNamespace]: {
    headerTitle: 'Notifications',
    markAllAsRead: 'Mark all as read',
    emptyTitle: 'No Notifications',
    emptyMessage: "You don't have any notifications at the moment ",
  },
};
